import React, { useState } from 'react';

import { captureCharts, reportPayload, requestReport } from './acgReport';

/**
 * « TÉLÉCHARGER LE RAPPORT » — le bilan de la séance en PDF, à envoyer aux
 * participants.
 *
 * Il est posé à côté du bouton qui fait avancer, et il reste là QUAND CELUI-CI
 * DISPARAÎT : une fois la partie finie (`displayButton={false}`, cf.
 * gameFlow.js), l'écran de bilan est encore affiché derrière la barre de fin,
 * et c'est précisément le moment où un animateur va chercher son document.
 *
 * TROIS ÉTATS, PAS DEUX. La composition prend quelques secondes — le serveur
 * relit la partie, le catalogue des mesures et une agrégation de classement —
 * et un bouton qui ne dit rien pendant ce temps se fait cliquer trois fois.
 * L'échec, lui, s'affiche : il survient devant une salle, et un animateur doit
 * savoir s'il peut réessayer ou s'il doit récupérer le document plus tard.
 */
const ReportDownloadButton = ({ boardRef, pageData, gameStatus, view }) => {
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');

  const gameId = gameStatus?._id;
  if (!gameId) return null;

  const download = async () => {
    setState('working');
    setError('');
    try {
      const payload = reportPayload({ pageData, gameStatus, view });
      payload.charts = captureCharts(boardRef?.current);
      const { blob, filename } = await requestReport(gameId, payload);

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      // Différée : révoquer l'URL dans la foulée du clic annule le
      // téléchargement sur certains navigateurs, qui n'ont pas encore lu le
      // blob quand la fonction rend la main.
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      setState('idle');
    } catch (requestError) {
      console.error('Rapport de séance indisponible:', requestError);
      setError(requestError.message || 'Le rapport n\'a pas pu être généré.');
      setState('idle');
    }
  };

  return (
    <div className="report-download">
      <button
        type="button"
        className="report-button"
        onClick={download}
        disabled={state === 'working'}
      >
        {state === 'working' ? 'Composition du rapport…' : '📄 Télécharger le rapport'}
      </button>
      {error && <p className="report-error">{error}</p>}
    </div>
  );
};

export default ReportDownloadButton;
